import React from 'react';
import { Line, Card, ContentCard, Video } from '../Common';
import Service from './Common/Service/Service';
import Courses from './Common/Course/Courses'
import flower from './flower.svg';
import car from './car.svg';
import parcel from './parcel.svg';

const backgroundStyle = {
  backgroundPosition: 'center center',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
};

const circleStyle = {
  marginBottom: '20px',
  height: '200px',
  width: '200px',
  borderRadius: '3000px',
  backgroundColor: '#ebebeb',
  minWidth: '0px',
  position: 'relative',
  ...backgroundStyle
};

const noBackground = {
  zIndex: 0,
  backgroundColor: '#ffffff',
  borderColor: '#f0f0f0',
  borderStyle: 'solid',
  borderWidth: '1px',
};

const Services = () => {
  return (
    <div>
      <Line>
        <Card
          cardBgr="/images/401.jpg"
          thumb="/images/401-low.jpg"
          backgroundStyle={backgroundStyle}
        >
          <Service
            title={
              <span>Категория<br/>A, B</span>
            }
            image={car}
            description="Мопед, мотоцикл, автомобиль"
          />
        </Card>
        <Card
          cardBgr="/images/400.jpg"
          thumb="/images/400-low.jpg"
          backgroundStyle={backgroundStyle}
        >
          <Service
            title="Экстремальное вождение"
            image={parcel}
            description="Научим водить без стресса"
          />
        </Card>
        <Card
          cardBgr="/images/402.jpg"
          thumb="/images/402-low.jpg"
          backgroundStyle={backgroundStyle}
        >
          <Service
            title={
              <span>Курс<br/>автоледи</span>
            }
            image={flower}
            description={
              <span>Для самых классных<br/>девчонок</span>
            }
          />
        </Card>
      </Line>
      <Line
        title={
          <span>
            Цены на обучение<br/>(категория B)
          </span>
        }
        secondary={
          <span>
            <span className="important">Честная и заблаговременная</span> информация о действительной
        стоимости обучения.Информацию о ценах на специальные программы
        (экстремальное вождение, курс «Автоледи») вы можете получить по телефону:
          <span className="important"> +7 (951) 938-40-29</span>
          </span>
        }
      >
        <Card
          backgroundStyle={noBackground}
        >
          <Courses
            title="Теоретический курс "
            time="(134 часа)"
            details={[
              'правила и безопасность дорожного движения',
              'устройство и техническое обслуживание легкового автомобиля',
              'теория вождения и безопасность управления автомобилем',
              'правила оказания первой доврачебной помощи',
            ]}
            price='4.000₽'
          />
        </Card>
        <Card
          backgroundStyle={noBackground}
        >
          <Courses
            title="Практический курс"
            time="(56 часов)"
            details={[
              'механическая коробка передач',
              'обучение и сдача экзамена на том же автомобиле',
              'опытные инструкторы',
            ]}
            price='16.000₽'
          />
        </Card>
        <Card
          backgroundStyle={{
            ...noBackground,
            backgroundColor: '#edc148',
          }}
        >
          <Courses
            title="Полная стоимость обучения"
            details={[
              'Теоретический курс (134 часа) + Практический курс (56 часов)',
              'Возможна рассрочка на время обучения!',
            ]}
            price='20.000₽'
            important
          />
        </Card>
      </Line>
      <Line
        title="Скидки на теоретический курс"
        secondary="Мы предоставляем скидки студентам, именинникам и постоянным клиентам"
      >
        <Card>
          <ContentCard
            title="Студентам"
            description="Скидка каждому студенту дневного отделения"
          >
            <Video src="/images/giphy3.mp4" />
          </ContentCard>
        </Card>
        <Card>

          <ContentCard
            title="Именинникам"
            description="Скидка в день рожденья—приятный бонус!"
          >
            <Video src="/images/giphy4.mp4" />
          </ContentCard>
        </Card>
        <Card>

          <ContentCard
            title="Постоянным клиентам"
            description="Мы страшно любим своих клиентов и ничего для них не жалеем!"
          >
            <Video src="/images/giphy5.mp4" />
          </ContentCard>
        </Card>
      </Line>
    </div>
  );
};


export default Services;



// WEBPACK FOOTER //
// ./src/components/Services/Services.jsx